module.exports = __webpack_public_path__ + "img/carshare.ac3729d7.png";